import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface RelatedPet {
  id: number | string;
  name: string;
  breed: string;
  age: string;
  image: string;
  alt: string;
  location: string;
}

interface RelatedPetsProps {
  pets: RelatedPet[];
}

const RelatedPets = ({ pets }: RelatedPetsProps) => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-headline font-semibold text-foreground">
        Similar Pets You Might Love
      </h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {pets.map((pet) => (
          <Link
            key={pet.id}
            href={`/pet-profile/${pet.id}`}
            className="group bg-card rounded-xl overflow-hidden border border-border hover:shadow-elevated transition-all duration-300"
          >
            <div className="relative aspect-square overflow-hidden">
              <AppImage
                src={pet.image}
                alt={pet.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
              />
            </div>
            <div className="p-4 space-y-2">
              <h3 className="text-lg font-body font-semibold text-foreground group-hover:text-primary transition-colors">
                {pet.name}
              </h3>
              <p className="text-sm text-muted-foreground font-body">{pet.breed}</p>
              <div className="flex items-center justify-between pt-2">
                <div className="flex items-center gap-1 text-sm text-muted-foreground font-body">
                  <Icon name="CalendarIcon" size={16} variant="outline" />
                  <span>{pet.age}</span>
                </div>
                <div className="flex items-center gap-1 text-sm text-muted-foreground font-body">
                  <Icon name="MapPinIcon" size={16} variant="outline" />
                  <span>{pet.location}</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedPets;